exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.file-row-stats {\n  font-size: 12px;\n}\n", ""]);

// exports
